export const NIKKELocale = {
  en: {
    radio_title: 'All',
    region_title: 'Nikke',
    market_title: 'Nikke',
    search: 'Search',
    select_all: 'Select All',
    clear_all: 'Clear All',
    button_region: 'Nikke',
    button_market: 'Nikke',
    search_none: 'No result found',
    country_no_data: 'No result found',
  },
  cn: {
    radio_title: '全部',
    region_title: '角色',
    market_title: '角色',
    search: '搜索',
    select_all: '全选',
    clear_all: '清空',
    button_region: '角色',
    button_market: '角色',
    search_none: '无匹配项',
    country_no_data: '无匹配项',
  },
};

export const NIKKERadioOptions = [
  {
    value: 'global',
    text: 'All Nikkes',
    textCN: '全部',
  },
];
